class CountdownData extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.getAttribute("date")).getTime();
    this.daysElement = this.querySelector(".countdown-days");
    this.hoursElement = this.querySelector(".countdown-hours");
    this.minutesElement = this.querySelector(".countdown-minutes");
    this.secondsElement = this.querySelector(".countdown-seconds");

    this.updateCountdown();
    this.timer = setInterval(() => this.updateCountdown(), 1000);
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.targetDate - now;

    if (distance < 0) {
      clearInterval(this.timer);
      this.innerHTML = "EXPIRÉ";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (days == 0) {
      this.daysElement.classList.add("hidden");
      this.querySelector(".countdown-days-label").classList.add("hidden");
    } else {
      this.daysElement.classList.remove("hidden");
      this.querySelector(".countdown-days-label").classList.remove("hidden");
    }

    if (hours == 0) {
      this.hoursElement.classList.add("hidden");
      this.querySelector(".countdown-hours-label").classList.add("hidden");
    } else {
      this.hoursElement.classList.remove("hidden");
      this.querySelector(".countdown-hours-label").classList.remove("hidden");
    }

    if (minutes == 0) {
      this.minutesElement.classList.add("hidden");
      this.querySelector(".countdown-minutes-label").classList.add("hidden");
    } else {
      this.minutesElement.classList.remove("hidden");
      this.querySelector(".countdown-minutes-label").classList.remove("hidden");
    }

    this.daysElement.textContent = String(days).padStart(2, "0");
    this.hoursElement.textContent = String(hours).padStart(2, "0");
    this.minutesElement.textContent = String(minutes).padStart(2, "0");
    this.secondsElement.textContent = String(seconds).padStart(2, "0");
  }
}

customElements.define("countdown-data", CountdownData);
